(() => {
  const wrapper = document.querySelector('[data-cabane-breadcrumbs]');
  const path = value => value.replace(/^\/en(?=\/|$)/, '');
  const isListing = url => /^\/(collections(?:\/[^/]+)?\/?|search\/?|pages\/catalogue\/?)$/.test(path(url.pathname));
  const read = key => { try { return JSON.parse(sessionStorage.getItem(key)); } catch (_) { return null; } };
  const save = (key, value) => { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (_) {} };
  const sameURL = (a, b) => a.pathname === b.pathname && a.search === b.search;
  const data = window.CabaneCategoryNavigation;
  const translate = text => document.documentElement.lang.startsWith('en') ? window.CabaneBreadcrumbLabels?.en[text] || text : text;
  const root = (wrapper?.dataset.root || window.Shopify?.routes?.root || '/').replace(/\/$/, '');
  const local = value => root + value.replace(/^\/en(?=\/|$)/, '');
  const replaceCrumbs = items => {
    const list = wrapper.querySelector('[data-breadcrumb-list]');
    const all = [{title:wrapper.dataset.homeLabel,url:root+'/'},...items];
    list.replaceChildren(...all.map((item,index) => {
      const li = document.createElement('li'), el = document.createElement(index===all.length-1?'span':'a');
      el.textContent = item.title;
      if (index === all.length-1) {el.setAttribute('aria-current','page');el.title=item.title;}
      else el.href = item.url;
      li.append(el); return li;
    }));
  };
  const pageTitle = wrapper?.querySelector('[aria-current="page"]')?.textContent.trim();
  const listingCrumbs = (url, title) => window.CabaneBreadcrumbRoutes?.resolve(url, title, root + '/')?.map(item => ({...item,title:translate(item.title)}));
  if (wrapper && data && ['collection','search'].includes(wrapper.dataset.pageType)) {
    const items = listingCrumbs(new URL(location.href), pageTitle);
    if (items?.length) replaceCrumbs(items);
  }
  const current = new URL(location.href);
  if (isListing(current)) {
    document.addEventListener('click', event => {
      const link=event.target.closest('a[href]'); if(!link)return;
      const target=new URL(link.href,location.origin);
      if(target.origin!==location.origin || !/\/products\/[^/]+/.test(target.pathname))return;
      save('cabane-result-origin',{url:location.href,target:target.pathname,scroll:scrollY,time:Date.now(),categoryTitle:wrapper?.querySelector('[aria-current="page"]')?.textContent.trim()});
    },true);
    const restore=read('cabane-result-restore');
    if(restore?.url===location.href && Date.now()-restore.time<60000) {
      let attempts=0;
      const recover=()=>{window.scrollTo({top:restore.scroll,behavior:'instant'});if(++attempts<12 && document.documentElement.scrollHeight-innerHeight<restore.scroll)setTimeout(recover,100);};
      if(document.readyState==='complete')recover();else window.addEventListener('load',recover,{once:true});
      save('cabane-result-restore',null);
    }
  }
  const back=wrapper?.querySelector('[data-results-return]');
  if (!back) return;
  let previous;
  try { previous = document.referrer ? new URL(document.referrer) : null; } catch (_) {}
  const stored=read('cabane-result-origin');
  const navigation=performance.getEntriesByType('navigation')[0]?.type;
  const trustedStored=stored && stored.target===location.pathname && Date.now()-stored.time<1800000 && (previous && previous.origin===location.origin && isListing(previous) || navigation==='reload' || navigation==='back_forward');
  let origin;
  try { origin=trustedStored ? new URL(stored.url) : previous; } catch (_) {}
  if (wrapper.dataset.pageType === 'product') {
    let ancestors = trustedStored && origin ? listingCrumbs(origin, stored.categoryTitle) : null;
    if (!ancestors?.length && wrapper.dataset.handle) {
      const fallback = new URL(local('/collections/' + wrapper.dataset.handle), location.origin);
      const collectionLink = wrapper.querySelector('[data-breadcrumb-list] li:nth-last-child(2) a');
      ancestors = listingCrumbs(fallback, collectionLink?.textContent.trim());
    }
    if (ancestors?.length) replaceCrumbs([...ancestors,{title:pageTitle}]);
  }
  if (!origin || origin.origin!==location.origin || !isListing(origin))return;
  back.href=origin.href;back.hidden=false;
  back.addEventListener('click',event=>{
    if(event.button!==0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)return;
    if(trustedStored && sameURL(origin,new URL(stored.url))) save('cabane-result-restore',{url:origin.href,scroll:stored.scroll,time:Date.now()});
  });
})();
